/** Used for Google Analytics */

export enum Events {
  ChangeMainPhoto = "change_main_photo",
  Filters = "filters",
  PricingDataCardClick = "pricing_data_card_click",
  PricingFlowTimeBags = "pricing_time_bags",
  PricingFlowTimeOC = "pricing_time_other_categories",
  ProductMatchFlowTime = "product_match_flow_time",
  ReviewFlowTime = "review_flow_time",
}
export interface IFiltersApplied {
  filters_applied: string;
}
export interface ITimeToSubmitPM {
  total_time_to_submit_pm: string;
}
export interface ITimeToReview {
  total_time_to_review: string;
}
export interface ITimeToPricing {
  total_time_to_pricing: string;
}